import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/styles'
import Button from 'components/buttons/button'
import { DialogBase, dialogSizes } from 'dialogs/dialogBase'
import { styles } from './index.css'

class ConfirmDialog extends DialogBase {
  static propTypes = {
    context: PropTypes.shape({
      title: PropTypes.string,
      message: PropTypes.string,
      onConfirm: PropTypes.func.isRequired
    }).isRequired
  }
  static defaultProps = {
    context: {
      onConfirm: () => console.log('Confirmed...')
    }
  }
  modalSize () { return dialogSizes.MD }
  modalTitle () { return this.props.context.title || this.props.localize('common.confirm') }
  modalBody () { return this.props.context.message || this.props.localize('common.defaultConfirmMessage') }
  modalButtons () {
    const { classes } = this.props
    return (
      <div className={classes.buttons}>
        <Button color='primary' className='positive' onClick={this.yesButtonClicked}>{this.props.localize('common.yes')}</Button>
        <Button color='default' onClick={this.toggle}>{this.props.localize('common.no')}</Button>
      </div>
    )}
  yesButtonClicked = () => {
    this.toggle()
    this.props.context.onConfirm()
  }
}

export default withStyles(styles)(ConfirmDialog)
